import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import { CatalogoService } from '../../../../service/CatalogoService';
import * as generic from '../../../../components/Generico';
import { OrigenDatosTransaccion as OrigenDatosTransaccionModel } from '../../../../models/ficha/OrigenDatosTransaccion';
import { OrigenService } from '../../../../service/OrigenService';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';

export const DatosTransaccion = ({ toast, id, permss, catalogos, next, nuevoOrigen, soloLectura }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new OrigenDatosTransaccionModel({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue, clearErrors } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const origenService = new OrigenService();
    const catalogoService = new CatalogoService();
    const { inDrop, inText, inCalendar, inNumber } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [esRuc, setEsRuc] = useState(false);
    const [esRucRep, setEsRucRep] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    const [esCedulaRep, setEsCedulaRep] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [ciudadesPago, setCiudadesPago] = useState([]);
    const [ecuador, setEcuador] = useState(false);
    const [ecuadorPago, setEcuadorPago] = useState(false);
    const [esJuridica, setEsJuridica] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        origenService.consultarOrigen(id ?? 0, 'seccion1').then(res => {
            const cats = catalogos;
            const _origen = res.data.origen;

            if (!_origen) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }

            if (res.data.ciudades !== undefined) {
                setCiudades(res.data.ciudades);
                setEcuador(true);
            }
            if (res.data.ciudades_pago !== undefined) {
                setCiudadesPago(res.data.ciudades_pago);
                setEcuadorPago(true);
            }

            setEsJuridica(_origen.tipo_persona?.cat_id === cats?.juridica?.cat_id);
            setEsRuc(_origen.tipo_identificacion?.cat_id === cats?.ruc?.cat_id);
            setEsCedula(_origen.tipo_identificacion?.cat_id === cats?.cedula?.cat_id);
            setEsRucRep(_origen.tipo_identificacion_rep?.cat_id === cats?.ruc?.cat_id);
            setEsCedulaRep(_origen.tipo_identificacion_rep?.cat_id === cats?.cedula?.cat_id);

            _origen.fecha = generic.stringToDate(_origen.fecha);
            _origen.fecha_transaccion = generic.stringToDate(_origen.fecha_transaccion);

            reset(generic.renewValues(_origen, omodel.model));
        }).finally(() => setIsLoading(false));
    };

    const onSubmit = (data) => {
        setIsSaving(true);
        data.fecha = generic.dateToString(data.fecha);
        data.fecha_transaccion = generic.dateToString(data.fecha_transaccion);
        data.ec = catalogos?.ecuador?.cat_id;
        data.ruc = catalogos?.ruc;
        data.seccion = 'seccion1';
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa ?? null;
        data.juridica = catalogos?.juridica;

        const request = !id ? origenService.newOrigen(data) : origenService.editarOrigen({ ...data, id });
        request.then(res => {
            if (!id) {
                nuevoOrigen(res.data);
            }
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePais = (e, pago) => {
        if (pago) {
            setEcuadorPago(e.value?.cat_id === catalogos?.ecuador?.cat_id);
            setValue('provincia_pago', null);
            setValue('ciudad_pago', null);
            setCiudadesPago([]);
        } else {
            setEcuador(e.value?.cat_id === catalogos?.ecuador?.cat_id);
            setValue('provincia', null);
            setValue('ciudad', null);
            setCiudades([]);
        }
    }

    const onChangeProvincia = (e, pago) => {
        if (pago) {
            setValue('ciudad_pago', null);
            if (!e?.value) { setCiudadesPago([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesPago(res.data));
        } else {
            setValue('ciudad', null);
            if (!e?.value) { setCiudades([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudades(res.data));
        }
    }

    const onChangeTipo = (e) => {
        setEsRuc(e.value?.cat_id === catalogos?.ruc?.cat_id);
        setEsCedula(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion');
    }

    const onChangeTipoRep = (e) => {
        setEsRucRep(e.value?.cat_id === catalogos?.ruc?.cat_id);
        setEsCedulaRep(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion_rep');
    }

    const tipoDoc = esCedula ? 'IDEN_CEDULA' : (esRuc ? 'IDEN_RUC' : null);
    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || (esRuc ? 'RUC incorrecto' : 'Cédula incorrecta');
    };

    const tipoDocRep = esCedulaRep ? 'IDEN_CEDULA' : (esRucRep ? 'IDEN_RUC' : null);
    const reglaValidacionRep = (val) => {
        if (!tipoDocRep) return true;
        return generic.validarIdentificacionEcuador(val, tipoDocRep) || (esRucRep ? 'RUC incorrecto' : 'Cédula incorrecta');
    };

    const onChangeTpoPersona = (e) => {
        setEsJuridica(e.value?.cat_id === catalogos?.juridica?.cat_id);
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

            <Panel header={generic.renderPanelHeader('1', 'DATOS GENERALES', 'pi pi-file')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inCalendar('fecha', {}, 3)}
                    {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, ecuador ? 3 : 4)}
                    {ecuador ? (
                        <>
                            {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 3)}
                            {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 3)}
                        </>
                    ) : (
                        inText('canton', { icon: 'pi pi-map-marker' }, 5)
                    )}
                    {inDrop('tipo_persona', catalogos?.tipo, { lab: omodel.optionLabel, chn: onChangeTpoPersona }, esTipoEspecial ? 6 : 3)}
                    {inDrop('tipo_declarante', catalogos?.declarante, { lab: omodel.optionLabel }, esTipoEspecial ? 6 : 3)}
                    {!esTipoEspecial && inText('compania', { icon: 'pi pi-building' }, 3)}
                    {!esTipoEspecial && inText('proyecto', { icon: 'pi pi-briefcase' }, 3)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('2', 'INFORMACIÓN DEL CLIENTE', 'pi pi-id-card')} className="panel-ficha shadow-1 mb-4">
                {!esJuridica &&
                    <div className="formgrid grid">
                        {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipo }, 3)}
                        {inText('identificacion', { validate: reglaValidacion, keyFilter: 'num', icon: 'pi pi-id-card' }, 3)}
                        {esRuc && inText('razon_social', { icon: 'pi pi-building' }, 6)}
                        {!esRuc && inText('nombres', { icon: 'pi pi-user' }, 3)}
                        {!esRuc && inText('apellidos', { icon: 'pi pi-user' }, 3)}
                    </div>
                }

                {esJuridica &&
                    <div className="formgrid grid">
                        {inDrop('tipo_identificacion_rep', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipoRep }, 3)}
                        {inText('identificacion_rep', { validate: reglaValidacionRep, keyFilter: 'num', icon: 'pi pi-id-card' }, 3)}
                        {esRucRep && inText('razon_social_rep', { icon: 'pi pi-building' }, 6)}
                        {!esRucRep && inText('nombres_rep', { icon: 'pi pi-user' }, 3)}
                        {!esRucRep && inText('apellidos_rep', { icon: 'pi pi-user' }, 3)}
                    </div>
                }
            </Panel>

            <Panel header={generic.renderPanelHeader('3', 'DATOS DE LA TRANSACCIÓN', 'pi pi-money-bill')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inText('descripcion', { icon: 'pi pi-align-left' }, 6)}
                    {inText('proposito', { icon: 'pi pi-align-left' }, 6)}
                    {inNumber('valor_total', 2, true, {}, 3)}
                    {inText('ubicacion_bien', { icon: 'pi pi-map-marker' }, 6)}
                    {inDrop('moneda', catalogos?.moneda, { lab: omodel.optionLabel }, 3)}
                </div>

                <div className="formgrid grid">
                    {inDrop('pais_pago', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: true }, ecuadorPago ? 3 : 4)}
                    {ecuadorPago ? (
                        <>
                            {inDrop('provincia_pago', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: true }, 3)}
                            {inDrop('ciudad_pago', ciudadesPago, { lab: omodel.optionLabel }, 3)}
                        </>
                    ) : (
                        inText('canton_pago', { icon: 'pi pi-map-marker' }, 5)
                    )}
                    {inCalendar('fecha_transaccion', {}, 3)}
                </div>
            </Panel>

            <BottomActionBar onNext={next} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}
